import React, { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const SearchFormLazyLoading = () => {
    return (
        <div className="d-flex flex-column w-100 py-2 gap-3">
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline  />
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline />
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline />
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline />
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline />
            <Skeleton height={32} width='91%' className="d-block mx-auto border" inline />
            <Skeleton height={20} width={'50%'} className="col-11 d-block ms-3 border mt-2" inline />
            <Skeleton height={20} width={'50%'} className="col-11 d-block ms-3 border" inline />
            <div className="d-d-block align-items-center">
                <Skeleton height={15} width='91%' className="d-block mx-auto border my-2 mt-2" inline />
                <Skeleton height={15} width='91%' className="d-block mx-auto border my-2" inline />
                <Skeleton height={15} width='91%' className="d-block mx-auto border my-2" inline />
            </div>
            <Skeleton height={30} width={'50%'} className="col-11 d-block ms-3 border" inline />
        </div>
    );
};

export default memo(SearchFormLazyLoading);
